import React from 'react';

import {
  VStack,
  Button,
  ScrollArea,
  Text,
  ButtonGroup,
  SkeletonText,
  Float,
  Circle,
} from '@chakra-ui/react';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import CategorySpecificFilters from '../../../containers/SearchPage/SearchFiltersPopUp/SearchFiltersCategory';
import { FormattedMessage } from '../../../util/reactIntl';

/**
 * SearchFiltersPrimary component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {boolean} [props.isSecondaryFiltersOpen] - Whether the secondary filters are open
 * @param {Function} [props.toggleSecondaryFiltersOpen] - The function to toggle the secondary filters
 * @param {number} [props.selectedSecondaryFiltersCount] - The number of selected secondary filters
 * @returns {JSX.Element}
 */
const SearchFiltersDesktop = props => {
  const {
    isModalOpen,
    setIsModalOpen,
    selectedFiltersCount = 0,
    updateQueryParams,
    sortByComponent,
    searchInProgress,
    totalItems,
  } = props;

  const hasSelectedFilters = selectedFiltersCount > 0;

  return (
    <VStack align="start" pb={0}>
      <ButtonGroup zIndex={9} justify={'space-between'}>
        <div>{sortByComponent}</div>

        <Button
          variant={'outline'}
          onClick={() => setIsModalOpen(!isModalOpen)}
          borderColor={hasSelectedFilters ? 'gray.900' : ''}
          borderWidth={hasSelectedFilters ? '0.15rem' : ''}
          rounded={'3xl'}
        >
          {selectedFiltersCount > 0 && (
            <Float placement={'top-end'} borderColor={'white'} borderWidth={'0.125rem'}>
              <Circle size="5" bg="almostBlack" color="white">
                {selectedFiltersCount}
              </Circle>
            </Float>
          )}
          <TuneRoundedIcon /> Filters
        </Button>
      </ButtonGroup>
      <ScrollArea.Root variant={'hover'} flex="1" maxW="100%">
        <ScrollArea.Viewport
          maxW="100%"
          overflow={'visible'}
          whiteSpace="nowrap"
          scrollSnapType="x mandatory"
          pt="0.5rem"
          pb="0.5rem"
        >
          <ScrollArea.Content paddingEnd="3" textStyle="sm" overflowY="visible">
            <CategorySpecificFilters updateQueryParams={updateQueryParams} />
          </ScrollArea.Content>
        </ScrollArea.Viewport>
      </ScrollArea.Root>
      {searchInProgress ? (
        <SkeletonText loading={searchInProgress} noOfLines={1} w={'30%'} mt={'1.2rem'} />
      ) : (
        <Text textStyle="md" textAlign={'left'} fontWeight={'semibold'} mb={0}>
          <FormattedMessage id="MainPanelHeader.foundResults" values={{ count: totalItems }} />
        </Text>
      )}
    </VStack>
  );
};

export default SearchFiltersDesktop;
